export const GET_PAYMENT_PLANS_LIST_FAIL = "GET_PAYMENT_PLANS_LIST_FAIL";
export const GET_PAYMENT_PLANS_LIST_REQUEST = "GET_PAYMENT_PLANS_LIST_REQUEST";
export const GET_PAYMENT_PLANS_LIST_SUCCESS = "GET_PAYMENT_PLANS_LIST_SUCCESS";

export const CREATE_PAYMENT_PLAN_FAIL = "CREATE_PAYMENT_PLAN_FAIL";
export const CREATE_PAYMENT_PLAN_REQUEST = "CREATE_PAYMENT_PLAN_REQUEST";
export const CREATE_PAYMENT_PLAN_SUCCESS = "CREATE_PAYMENT_PLAN_SUCCESS";

export const GET_PROMO_CODE_LIST_FAIL = "GET_PROMO_CODE_LIST_FAIL";
export const GET_PROMO_CODE_LIST_REQUEST = "GET_PROMO_CODE_LIST_REQUEST";
export const GET_PROMO_CODE_LIST_SUCCESS = "GET_PROMO_CODE_LIST_SUCCESS";

export const CREATE_PROMO_CODE_FAIL = "CREATE_PROMO_CODE_FAIL";
export const CREATE_PROMO_CODE_REQUEST = "CREATE_PROMO_CODE_REQUEST";
export const CREATE_PROMO_CODE_SUCCESS = "CREATE_PROMO_CODE_SUCCESS";

export const GET_PROMO_USAGE_LIST_FAIL = "GET_PROMO_USAGE_LIST_FAIL";
export const GET_PROMO_USAGE_LIST_REQUEST = "GET_PROMO_USAGE_LIST_REQUEST";
export const GET_PROMO_USAGE_LIST_SUCCESS = "GET_PROMO_USAGE_LIST_SUCCESS";

export const GET_SERVICE_CHARGE_LIST_FAIL = "GET_SERVICE_CHARGE_LIST_FAIL";
export const GET_SERVICE_CHARGE_LIST_REQUEST =
  "GET_SERVICE_CHARGE_LIST_REQUEST";
export const GET_SERVICE_CHARGE_LIST_SUCCESS =
  "GET_SERVICE_CHARGE_LIST_SUCCESS";

export const CREATE_SERVICE_CHARGE_FAIL = "CREATE_SERVICE_CHARGE_FAIL";
export const CREATE_SERVICE_CHARGE_REQUEST = "CREATE_SERVICE_CHARGE_REQUEST";
export const CREATE_SERVICE_CHARGE_SUCCESS = "CREATE_SERVICE_CHARGE_SUCCESS";

export const GET_DLQ_MESSAGES_LIST_FAIL = "GET_DLQ_MESSAGES_LIST_FAIL";
export const GET_DLQ_MESSAGES_LIST_REQUEST = "GET_DLQ_MESSAGES_LIST_REQUEST";
export const GET_DLQ_MESSAGES_LIST_SUCCESS = "GET_DLQ_MESSAGES_LIST_SUCCESS";

export const GET_COUPON_LIST_FAIL = "GET_COUPON_LIST_FAIL";
export const GET_COUPON_LIST_REQUEST = "GET_COUPON_LIST_REQUEST";
export const GET_COUPON_LIST_SUCCESS = "GET_COUPON_LIST_SUCCESS";

export const GET_COUPON_USAGE_LIST_FAIL = "GET_COUPON_USAGE_LIST_FAIL";
export const GET_COUPON_USAGE_LIST_REQUEST = "GET_COUPON_USAGE_LIST_REQUEST";
export const GET_COUPON_USAGE_LIST_SUCCESS = "GET_COUPON_USAGE_LIST_SUCCESS";

export const CREATE_COUPON_FAIL = "CREATE_COUPON_FAIL";
export const CREATE_COUPON_REQUEST = "CREATE_COUPON_REQUEST";
export const CREATE_COUPON_SUCCESS = "CREATE_COUPON_SUCCESS";

export const GET_PAYMENT_PLAN_DETAIL_REQUEST =
  "GET_PAYMENT_PLAN_DETAIL_REQUEST";
export const GET_PAYMENT_PLAN_DETAIL_SUCCESS =
  "GET_PAYMENT_PLAN_DETAIL_SUCCESS";
export const GET_PAYMENT_PLAN_DETAIL_FAIL = "GET_PAYMENT_PLAN_DETAIL_FAIL";

export const UPDATE_PAYMENT_PLAN_REQUEST = "UPDATE_PAYMENT_PLAN_REQUEST";
export const UPDATE_PAYMENT_PLAN_SUCCESS = "UPDATE_PAYMENT_PLAN_SUCCESS";
export const UPDATE_PAYMENT_PLAN_FAIL = "UPDATE_PAYMENT_PLAN_FAIL";

export const UPDATE_COUPON_FAIL = "UPDATE_COUPON_FAIL";
export const UPDATE_COUPON_SUCCESS = "UPDATE_COUPON_SUCCESS";
export const UPDATE_COUPON_REQUEST = "UPDATE_COUPON_REQUEST";

export const UPDATE_PROMO_REQUEST = "UPDATE_PROMO_REQUEST";
export const UPDATE_PROMO_FAIL = "UPDATE_PROMO_FAIL";
export const UPDATE_PROMO_SUCCESS = "UPDATE_PROMO_SUCCESS";

export const CREATE_PLAN_DISCOUNT_REQUEST = "CREATE_PLAN_DISCOUNT_REQUEST";
export const CREATE_PLAN_DISCOUNT_FAIL = "CREATE_PLAN_DISCOUNT_FAIL";
export const CREATE_PLAN_DISCOUNT_SUCCESS = "CREATE_PLAN_DISCOUNT_SUCCESS";

export const UPDATE_PAYMENT_PLAN_DISCOUNT_REQUEST = "UPDATE_PAYMENT_PLAN_DISCOUNT_REQUEST";
export const UPDATE_PAYMENT_PLAN_DISCOUNT_SUCCESS = "UPDATE_PAYMENT_PLAN_DISCOUNT_SUCCESS";
export const UPDATE_PAYMENT_PLAN_DISCOUNT_FAIL = "UPDATE_PAYMENT_PLAN_DISCOUNT_FAIL";

export const CREATE_MANUAL_CREDIT_GRANT_REQUEST = "CREATE_MANUAL_CREDIT_GRANT_REQUEST";
export const CREATE_MANUAL_CREDIT_GRANT_SUCCESS = "CREATE_MANUAL_CREDIT_GRANT_SUCCESS";
export const CREATE_MANUAL_CREDIT_GRANT_FAIL = "CREATE_MANUAL_CREDIT_GRANT_FAIL";

export const GET_ENTITY_TRANSACTIONS_REQUEST = "GET_ENTITY_TRANSACTIONS_REQUEST";
export const GET_ENTITY_TRANSACTIONS_SUCCESS = "GET_ENTITY_TRANSACTIONS_SUCCESS";
export const GET_ENTITY_TRANSACTIONS_FAIL = "GET_ENTITY_TRANSACTIONS_FAIL";
